import { getAnalyticsEnvironment } from '@src/config/env'
import { HTTP_HEADERS } from '@src/constants/common.constants'
import { FEATURES, MODULES } from '@src/quince-site-common/src/constants/template-info'
import { sgtmServiceClient } from '@src/quince-site-common/src/utils/HttpClient'
import { captureException } from '@src/quince-site-common/src/utils/sentryUtil'

import { getAppLovinTrackingData } from './utils/applovinTracking.utils'
import { processResponseHeaders } from './utils/handleSgtmApi.utils'
import { getRedditTrackingData } from './utils/redditTracking.utils'

export const handleSgtmApi = (
  eventData: Record<string, unknown>,
  event_name: string,
  event_key: string,
  shouldProcessResponseHeaders = false,
) => {
  // Get Reddit tracking data
  const redditTrackingData = getRedditTrackingData()

  // Get AppLovin tracking data
  const appLovinTrackingData = getAppLovinTrackingData()

  // Add Reddit tracking data to event if available (using Reddit CAPI field names)
  // Add AppLovin tracking data to event if available (using AppLovin field names)
  const enhancedEventData = {
    ...eventData,
    ...(redditTrackingData.clickId && { click_id: redditTrackingData.clickId }),
    ...(redditTrackingData.uuid && { uuid: redditTrackingData.uuid }),
    ...(appLovinTrackingData.aleid && { aleid: appLovinTrackingData.aleid }),
    ...(appLovinTrackingData.axwrt && { axwrt: appLovinTrackingData.axwrt }),
    ...(appLovinTrackingData.alart && { alart: appLovinTrackingData.alart }),
    env: getAnalyticsEnvironment(),
  }

  const payload = {
    event: event_name,
    [event_key]: JSON.stringify(enhancedEventData),
  }

  const config = {
    headers: {
      [HTTP_HEADERS.CONTENT_TYPE]: HTTP_HEADERS.APPLICATION_JSON,
    },
  }

  sgtmServiceClient
    .post('/ecomm', payload, config)
    .then(res => {
      if (shouldProcessResponseHeaders) {
        // Type assertion to handle AxiosResponseHeaders type
        processResponseHeaders(res.headers as Record<string, string>)
      }
    })
    .catch((err: unknown) => {
      captureException(err, {
        module: MODULES.INTERNAL_ANALYTICS,
        feature: FEATURES.SGTM_API,
      })
    })
}
